import { Input } from '../ui/input';
import { InputCurrency } from './input-currency';
import InputPassword from './input-password';
import InputPrefix from './input-prefix';

const CustomInput = {
    Root: Input,
    Password: InputPassword,
    Prefix: InputPrefix,
    Currency: InputCurrency,
    name: 'CustomInput',
};

export type * from './input-currency';
export default CustomInput;
